import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Reveal, Overline, BookButton } from "@/components/bits";

const PILLARS = [
  { title: "Undersøkelse", text: "Behandlingen starter alltid med en grundig undersøkelse og gjennomgang av din historie." },
  { title: "Manuell behandling", text: "Osteopaten bruker hendene til å undersøke og behandle muskler, ledd og vev." },
  { title: "Råd og øvelser", text: "Du får råd, øvelser og veiledning tilpasset din situasjon, aktivitet og hverdag." },
];

export default function VaareTjenester() {
  return (
    <>
      <Seo
        title="Våre tjenester | Actus Osteopati – Osteopati og tørrnåling i Oslo sentrum"
        description="Les om hva osteopati og tørrnåling (dry needling) er, og hvordan vi jobber hos Actus Osteopati på Lilletorget 1 i Oslo sentrum."
      />
      <PageHeader
        overline="Actus Osteopati"
        title="Våre tjenester"
        testId="vaare-tjenester-heading"
      />

      <section data-testid="osteopati-content" className="bg-paper py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal className="text-center max-w-2xl mx-auto">
            <Overline>Hva er osteopati?</Overline>
            <h2 className="font-display font-light text-2xl md:text-3xl lg:text-4xl leading-tight">
              Kroppen sett i sammenheng
            </h2>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-ink-soft">
              Osteopati er en manuell behandlingsform med fokus på muskel- og
              skjelettsystemet. Målet er å forbedre bevegelse og funksjon ved å
              se hvordan ulike deler av kroppen påvirker hverandre.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Hver pasient får en individuell vurdering. Ut fra undersøkelsen
              tilpasses behandlingen deg – alltid i et trygt og profesjonelt
              rammeverk.
            </p>
          </Reveal>
          <div className="mt-16 md:mt-24 grid md:grid-cols-3 gap-10 md:gap-14 max-w-5xl mx-auto">
            {PILLARS.map((p, i) => (
              <Reveal key={p.title} delay={0.1 + i * 0.08}>
                <div className="text-center border-t border-ink/10 pt-9">
                  <h3 className="font-display font-normal text-xl md:text-2xl">{p.title}</h3>
                  <p className="mt-3 text-sm md:text-base text-ink-soft leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="torrnaling-content" className="bg-beige py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal className="text-center max-w-2xl mx-auto">
            <Overline>Hva er tørrnåling?</Overline>
            <h2 className="font-display font-light text-2xl md:text-3xl lg:text-4xl leading-tight">
              Tørrnåling (Dry Needling)
            </h2>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-ink-soft">
              Tørrnåling, også kalt dry needling, er en behandlingsmetode hvor
              tynne, sterile nåler føres inn i muskulaturen for å behandle
              muskulære smerter og ømhet. Behandlingen kan rettes mot sensitive
              områder i muskulaturen, ofte omtalt som triggerpunkter eller
              muskelknuter.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Metoden benyttes som et supplement til osteopatisk behandling ved
              muskel- og skjelettplager, og kan bidra til kortvarig
              smertelindring og bedret bevegelighet.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Hos oss tilpasses behandlingen individuelt, og tørrnåling benyttes
              når behandleren vurderer at det er hensiktsmessig ut fra dine
              plager og behov.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Har du spørsmål om tørrnåling, er du velkommen til å ta kontakt
              med oss.
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="tjenester-cta" className="bg-olive text-sand py-24 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <h2 className="font-display font-light text-2xl md:text-3xl lg:text-4xl leading-tight">
              Klar for å bestille time?
            </h2>
            <div className="mt-10">
              <BookButton testId="vaare-tjenester-book-button" label="Book time nå" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
